const aaa = [
	{
		path: "videoList",
		component: () => import("@/views/jiaocheng/video/videoList.vue"),
		meta:{title:'视频教程'},
	},
]
export default aaa;